
import axios from "axios";
import { API_BASE_PATHS, API_ROUTES } from "../libs";
import { buildRequestConfig } from "./buildRequestConfig";

class EmbedService {
    async checkSlugAvailability(slug: string): Promise<{ available: boolean; message?: string }> {
        try {
            const config = await buildRequestConfig();
            const response = await axios.get(`${API_BASE_PATHS.EMBED_API}/${API_ROUTES.EMBED_SLUG_CHECK}/${slug}`, config);
            return response.data;
        } catch (error: any) {
            console.error("Error checking slug availability:", error);
            return { available: false, message: error?.response?.data?.message ?? error?.message };
        }
    }

    async createOrUpdateSlug(mediaId: string, slug: string): Promise<{ success: boolean; message?: string }> {
        try {
            const config = await buildRequestConfig();
            const response = await axios.post(`${process.env.REACT_APP_API_HOST}/${API_BASE_PATHS.EMBED_API}/${API_ROUTES.EMBED_SLUG}`, { mediaId, slug }, config);
            return { success: true, message: response.data?.message };
        } catch (error: any) {
            console.error("Error creating/updating slug:", error);
            return { success: false, message: error?.response?.data?.data?.message ?? error?.message };
        }
    }

}

export const embedService = new EmbedService();